import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';
import WarehouseDenialCauseForm from './form';
import './editWarehouseDenialCause.scss';

class EditWarehouseDenialCause extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(formValues) {
    const {code} = this.props;
    if (code) {
      return this.props.editWarehouseDenialCause(code, formValues);
    }
    return this.props.addWarehouseDenialCause(formValues);
  }

  render() {
    const {code, goBack, push} = this.props;

    return (
      <WarehouseDenialCauseForm
        goBack={goBack}
        push={push}
        code={code}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {code} = ownProps.params;
  return {
    code,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
  };
};

const {
  addWarehouseDenialCause,
  editWarehouseDenialCause,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  addWarehouseDenialCause,
  editWarehouseDenialCause,
})(EditWarehouseDenialCause));
